import { Loader2 } from "lucide-react";

/**
 * Full-screen loading state shown while a delete / supplier-update mutation
 * is in flight — the Tailwind equivalent of the legacy screen's Semantic UI
 * `Dimmer` + `Loader` combo (see
 * src/screens/ingredients/ingredientList/IngredientList.tsx), styled after
 * the refetch overlay card in the Recipe Simulator table
 * (src/screens/recipe_simulator/newList/components/RecipeListTable.tsx).
 */
const LoadingOverlay = () => {
  return (
    <div
      className="tw-fixed tw-inset-0 tw-z-50 tw-flex tw-items-center tw-justify-center tw-bg-white/75 tw-backdrop-blur-[1px]"
      role="status"
      aria-live="polite"
      aria-label="Loading"
    >
      <div className="tw-flex tw-flex-col tw-items-center tw-gap-3 tw-rounded-lg tw-border tw-border-primary/20 tw-bg-white tw-px-8 tw-py-5 tw-shadow-md">
        <Loader2 className="tw-h-8 tw-w-8 tw-animate-spin tw-text-primary" />
        <p className="tw-text-sm tw-font-medium tw-text-primary">Loading...</p>
      </div>
    </div>
  );
};

export default LoadingOverlay;
